import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=ce387202&"
import script from "./page-not-found.vue?vue&type=script&lang=js&"
export * from "./page-not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce387202')) {
      api.createRecord('ce387202', component.options)
    } else {
      api.reload('ce387202', component.options)
    }
    module.hot.accept("./page-not-found.vue?vue&type=template&id=ce387202&", function () {
      api.rerender('ce387202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/errors/page-not-found.vue"
export default component.exports